import { useEffect, useMemo } from 'react';
import { Form, Row, Col, Button } from "react-bootstrap";
import TomSelect from 'tom-select';
import 'tom-select/dist/css/tom-select.css'; // Import TomSelect CSS

const HeaderSelector = ({
  selectors,
  selected,
  setSelected,
  headerInfo,
  setCsvDownloadTracker,
}) => {
  const formattedAmount = Number(headerInfo.total_amount).toLocaleString()
  const formattedCount = Number(headerInfo.total_count).toLocaleString()

  const handleChange = (key, value) => {
    setSelected((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const resetFilters = () => {
    document.location.reload()
  };

  const downLoadCsv = () => {
    setCsvDownloadTracker(true);
  };

  const SelectorComponent = ({ fieldKey }) => {
    useEffect(() => {
      const options = selectors[fieldKey] ? selectors[fieldKey].map((option) => ({ value: option, text: option })) : [];
      new TomSelect(`#select-element-${fieldKey}`, {
        options: options,
        placeholder: 'Select to filter',
        maxItems: null, // Allows multiple selections
        create: false, // Enable the ability to create new options
        items: selected[fieldKey] // Set default selected items
      })
    }, [fieldKey, selectors, selected]);

    return (
      <Form.Group as={Row} className='align-items-center mb-2'>
        <Form.Label column xs={2}>
          {fieldKey.toUpperCase()}
        </Form.Label>
        <Col xs={10} className='grossmargin-select-wrapper'>
          <div className="tom-select-wrapper">
            <select
              id={`select-element-${fieldKey}`}
              multiple
              onChange={(e) => handleChange(fieldKey, Array.from(e.target.selectedOptions, option => option.value))}
            >
              {selectors[fieldKey] && selectors[fieldKey].map((option, index) => (
                <option key={index} value={option}>{option}</option>
              ))}
            </select>
          </div>
        </Col>
      </Form.Group>
    )
  }

  const memorizedSelectors = useMemo(() => (
    <Row>
        <Col md={4}>
          <SelectorComponent fieldKey={"sales"} />
        </Col>
        <Col md={5}>
          <SelectorComponent fieldKey={"customer"} />
        </Col>
        <Col md={3}>
          <SelectorComponent fieldKey={"AM"} />
        </Col>
      </Row>
  ), [selectors]);

  return (
    <div className="aging-container-selectors mb-5">
      {memorizedSelectors}
      <Row className="align-items-center">
        <Col md={2}>
          <strong>Total Amount: </strong>${formattedAmount}
        </Col>
        <Col md={2}>
          <strong>Total Count: </strong> {formattedCount}
        </Col>
        <Col xs={1} className="ml-auto">
          <Button onClick={resetFilters} size="sm">
            Reset Filters
          </Button>
        </Col>
        <Col xs={1}>
          <Button size="sm" onClick={downLoadCsv}>
            Export Table
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default HeaderSelector;
